import { render, staticRenderFns } from "./SPRLoading.vue?vue&type=template&id=8018f57a&scoped=true"
import script from "./SPRLoading.vue?vue&type=script&lang=js"
export * from "./SPRLoading.vue?vue&type=script&lang=js"
import style0 from "./SPRLoading.vue?vue&type=style&index=0&id=8018f57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8018f57a",
  null
  
)

export default component.exports